import React, { Component } from 'react';
import './WeatherCard.css';
import en from '../../language/en/ForecastByMunicipalities.json';
import es from '../../language/es/ForecastByMunicipalities.json';
import config from '../../config/config.json';

class WeatherCard extends Component {
	constructor() {
		super();
		this.state = {
			pronExt: [//para 4 días posteriores a la fecha actual
				{
					//1
				},
				{
					//2
				},
				{
					//3
				},
				{
					//4
				}
			],
			fade: 'fade-in',
			config: {
				lang: {
					en: en,
					es: es
				}
			},
			portletCurrentState: 'rounded-small',
			showFullScreen: false,

			firstVarMun: 'tempMax',
			secondVarMun: 'tempMin',
			thirdVarMun: 'tempAmb',
			separatorVarMun: ' / ',
			UMfirstVarMun: 'º',//unidad de medida
			UMSecondVarMun: 'º',
			currentVarIcon: {
				stgo: '',
				guama: '',
				songoMaya: '',
				sanLuis: '',
				palma: '',
				iiiF: '',
				contre: '',
				mella: '',
				iiF: ''
			},
			/*
			'tempMin',
			'tempMax',
			'tempAmb',
			'sConfort',
			'humedad',
			'presion',
			'precipitaciones',
			'vientoMin',
			'vientoMax',
			'dir_viento',
			'nubosidad',
			'visibilidad'
			*/
			iconMinimizeClass: 'down',
			portletPrevState: 'rounded-small'
		};

		window.scrollTo(0, 40);
	}

	componentDidMount() {
		const url = `${config.apiBaseUrl}/pronostico/pronextendido`;

		//Obteniendo el pronóstico provincial
		fetch(url)
			.then(
				res => {
					return res.json();
				}
			)
			.then(
				data => {
					//console.log('data = ', data);
					this.setState({
						pronExt: data
					});
				}
			)
			.catch(
				err => {
					console.log("error ", err);
				}
			);
	}

	handleMinimize () {
		// let clase = this.state.minimizeClass === ''? 'minimize': '';
		let portletPrevState = this.state.portletCurrentState;
		this.setState({portletCurrentState: 'portlet-minimize', showFullScreen: false});
	}

	handleFullScreen () {
		let portletPrevState = this.state.portletCurrentState;
		this.setState({ portletCurrentState: (this.state.showFullScreen) ? 'rounded-small' : 'portlet-fullscreen', showFullScreen: !this.state.showFullScreen })
	}

	render() {
		const lang = this.state.config.lang;
		const selectedLanguage = (this.props.lang === 'en') ? lang.en : lang.es;

		return (
			// <section id="WeatherCard" lang={this.props.lang}>
			// 	<div className={'WeatherCard ' + this.state.fade}>
			// 		<div className="container">
			// 			<div className="heading">
			// 				<h2><strong>{selectedLanguage.sectionTitle}</strong></h2>
			// 				{/* <a className="btn btn-circle blue-hoki btn-sm tooltips" data-container="body" data-placement="top" data-original-title="Close WeatherCard section" style={{ float: 'right'}} onClick={ () => {this.setState({fade: 'fade-out'}); this.props.in(false, 5);} }>
			// 	      	<i className="fa fa-times"/>
			// 	      </a> */}
			// 			</div>

			// 			<div className="row">

			// 				<div className="col-md-12">


			<div id="general-forecast" className={"portlet portlet-row-seperated box blue-hoki " + this.state.portletCurrentState}>
				<div className="portlet-title">
					<div className="caption">
						<i className="fa fa-gift"></i>{this.state.showFullScreen ? 'Santiago de Cuba' : 'Stgo'}
					</div>
					<div className="actions">
						<button className="btn btn-default btn-sm" onClick={() => this.handleMinimize()} id="btn-minimize">
							<i className={`fa fa-chevron-down`}></i>
						</button>
						
						<button className="btn btn-icon-only btn-default btn-sm fullscreen" data-original-title="" title="" onClick={() => this.handleFullScreen()}>
						</button>
					</div>
				</div>
				<div className="portlet-body">

					<div className="row">

						<div className="text-center">
							{this.state.showFullScreen && <h1>{this.state.pronExt[3].tempAmb}°</h1>}
							{this.state.showFullScreen && <h4>{this.state.pronExt[3].nubosidad}</h4>}
							{this.state.showFullScreen && <h5>{this.state.pronExt[3].tempMax}° / {this.state.pronExt[3].tempMin}°</h5>}

							{!this.state.showFullScreen && <h2 style={{ float: 'right', margin: '0' }}>{this.state.pronExt[3].tempAmb}°</h2>}
							{!this.state.showFullScreen && <div className="cloudy" style={{ float: 'left', marginTop: '5px' }}>{this.state.pronExt[3].nubosidad}</div>}
							{!this.state.showFullScreen && <h5 style={{ position: 'relative' }}>{this.state.pronExt[3].tempMax}° / {this.state.pronExt[3].tempMin}°</h5>}
						</div>

					</div>
					<div className="row">
						<div className="col-xs-6">{this.state.pronExt[2].fecha}</div>
						<div className="col-xs-2"><i className="fa fa-cloud"></i></div>
						<div className="col-xs-4">{this.state.pronExt[2].tempMax}° / {this.state.pronExt[2].tempMin}°</div>
					</div>
					<div className="row">
						<div className="col-xs-6">{this.state.pronExt[1].fecha}</div>
						<div className="col-xs-2"><i className="fa fa-cloud"></i></div>
						<div className="col-xs-4">{this.state.pronExt[1].tempMax}° / {this.state.pronExt[1].tempMin}°</div>
					</div>
					<div className="row">
						<div className="col-xs-6">{this.state.pronExt[0].fecha}</div>
						<div className="col-xs-2"><i className="fa fa-cloud"></i></div>
						<div className="col-xs-4">{this.state.pronExt[0].tempMax}° / {this.state.pronExt[0].tempMin}°</div>
					</div>

					<div className="row text-center">
						<h5>Pronóstico extendido</h5>
					</div>
					<div className="row">
						<label className="control-label"><strong>{selectedLanguage.forecastTags.sConfort}</strong></label><br />
						<div className="col-sm-6">
							<span style={{ display: 'block' }}>{selectedLanguage.forecastTags.humedad}</span>
							<div>
								<h4>Angle offset and arc</h4>
								<input className="knob" data-angleoffset="-125" data-anglearc="250" data-fgcolor="#3598dc" defaultValue={this.state.pronExt[3].humedad + ' %'} data-width="100" />
							</div>
						</div>
						<div className="col-sm-6">
							<span style={{ display: 'block' }}>{selectedLanguage.forecastTags.sConfort + this.state.pronExt[3].sConfort}º</span>
						</div>
					</div>
					<div className="row">
						<label className="control-label"><strong>{selectedLanguage.forecastTags.viento}</strong></label><br />
						<div className="col-sm-6">molinosdeviento</div>
						<div className="col-sm-6">
							<span style={{ display: 'block' }}>{selectedLanguage.forecastTags.dir_viento + this.state.pronExt[3].dir_viento}</span>
							<span>{selectedLanguage.forecastTags.velocidad + this.state.pronExt[3].vientoMin}-{this.state.pronExt[3].vientoMax} km/h</span>
						</div>
					</div>
					<div className="row">
						<label className="control-label"><strong><i className="fa fa-moon-o"></i>Cuarto creciente</strong></label><br />

					</div>


				</div>

			</div>

			// 				{/* </div>

			// 			</div>
			// 		</div>
			// 	</div>

			// </section> */}

		);
	}
}

export default WeatherCard;